module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website-w960.b30e8833.webp";